/* eslint-disable */
import { store } from '../../../store'
// import { httpgst, http } from '../../main'
import { httpgst, http } from '../../../main'
import router from '../../../router'

// initial state
const state = {}

// getters
const getters = {}

const actions = {
  async init({ commit, dispatch }, ctx) {
    try {
      this.dispatch('approvals/getExpenses', ctx)
      this.dispatch('approvals/getExpensesApproved', ctx)
      this.dispatch('approvals/getCategories', ctx)
      this.dispatch('approvals/getVehicles', ctx)
      this.dispatch('approvals/getTravelsType', ctx)
    } catch (error) {
      console.log(error)
    }
  },
  async getCategories({ commit, dispatch }, ctx) {
    try {
      const url = 'api/categories'
      const options = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      httpgst.defaults.headers.common['Authorization'] =
        'Bearer ' + store.state.userState.access_token
      const { data: response } = await httpgst.get(url, {}, options)
      ctx.categories = response.data
    } catch (error) {
      console.log(error)
    }
  },
  async getVehicles({ commit, dispatch }, ctx) {
    try {
      const url = 'api/vehicle'
      const options = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      httpgst.defaults.headers.common['Authorization'] =
        'Bearer ' + store.state.userState.access_token
      const { data: response } = await httpgst.get(url, {}, options)
      ctx.vehicles = response.data
    } catch (error) {
      console.log(error)
    }
  },
  async getExpenses({ commit, dispatch }, ctx) {
    try {
      ctx.loadingDataTable = true

      const url = 'api/travel-expenses-request/by-validator?status=IN_REVIEW'

      const options = { headers: { 'Content-Type': 'application/json' } }

      httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token

      const response = await httpgst.get(url, {}, options)
 
      ctx.expenses = response.data.data

    } catch (error) {
      console.log(error)
    } finally {
      ctx.loadingDataTable = false
    }
  },
  async getExpensesApproved({ commit, dispatch }, ctx) {
    try {
      ctx.loadingDataTable = true

      const url = 'api/travel-expenses-request/by-validator?status=APPROVED'

      const options = { headers: { 'Content-Type': 'application/json' } }

      httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token

      const response = await httpgst.get(url, {}, options)

      ctx.expensesValidate = response.data.data

    } catch (error) {
      console.log(error)
    } finally {
      ctx.loadingDataTable = false
    }
  },
  async getProjects({ commit, dispatch }, ctx) {
    try {
      
      const companyID = this.state.userLogged.company[0].id
      
      const url = `api/projects/getProjects/${companyID}`
      
      const options = { headers: { 'Content-Type': 'application/json'} }

      http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token

      const { data: response } = await http.get(url, {}, options)
      
      ctx.projects = response.data
    } catch (error) {
      console.log(error)
    }
  },
  async getTravelsType({ commit, dispatch }, ctx) {
    try {
      const url = `api/travel-type`
      const options = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      httpgst.defaults.headers.common['Authorization'] =
        'Bearer ' + store.state.userState.access_token
      const { data: response } = await httpgst.get(url, {}, options)
      ctx.travelTypes = response.data
    } catch (error) {
      console.log(error)
    }
  },
  async updateExpense({ commit, dispatch }, { ctx, id, expenseDTO: expense }) {
    try {
      if (expense.has_advance === 'caja_chica') {
        expense.is_petty_cash = 1
        expense.advance = false
        expense.amount_advance = 0
      }
  
      if (expense.has_advance === 'anticipo') {
        expense.is_petty_cash = 0
        expense.advance = true
      }
  
      if (expense.has_advance === 'reembolso') {
        expense.is_petty_cash = 0
        expense.advance = false
        expense.amount_advance = 0
      }
      ctx.loadingDialog.save = true

      if (expense.fuelRequests) {
        expense.fuelRequests = expense.fuelRequests.filter(
          req => req.gst_vehicle_id && req.gst_vehicle_id > 0
        )

        // Si después de filtrar no queda ninguno, borramos fuelRequests
        if (expense.fuelRequests.length === 0) {
          delete expense.fuelRequests
        }
      }

      const url = `api/travel-expenses-request/${id}`
      httpgst.defaults.headers.common['Authorization'] =
        'Bearer ' + store.state.userState.access_token
      const response = await httpgst.put(url, expense, {})
      ctx.showNotification(response, 'success')
      ctx.dialog = false
      ctx.expenses = []
      this.dispatch('approvals/getExpenses', ctx)
    } catch (error) {
      console.log(error)
      ctx.showNotification(error.response, 'error')
    } finally {
      ctx.loadingDialog.save = false
    }
  },
  async updateStatusExpense({ commit, dispatch }, { ctx, expenseID, data }) {
    try {
      ctx.loadingDialog.saveValidation = true
      const url = `api/update-status-request/${expenseID}`
      httpgst.defaults.headers.common['Authorization'] =
        'Bearer ' + store.state.userState.access_token
      const response = await httpgst.put(url, data, {})
      ctx.showNotification(response, 'success')
      ctx.dialogValidate = false
      ctx.dialogReject = false
      ctx.dialog = false
      ctx.expenses = []
      this.dispatch('approvals/init', ctx)
    } catch (error) {
      console.log(error)
      ctx.showNotification(error.response, 'error')
      ctx.validateRequestActivated = false
    } finally {
      ctx.loadingDialog.saveValidation = false
      ctx.validateRequestActivated = false
    }
  },
  async changeStatusExtension({ commit }, { ctx, extension, payload }) {
    try {
      const { status } = payload
      if (status === 'REJECTED') ctx.loadingDialog.extensionReject = extension
      if (status === 'APPROVED') ctx.loadingDialog.extensionValidate = extension

      const url = `api/travel-expenses-request/extension/change-status/${extension}`
      const options = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      httpgst.defaults.headers.common['Authorization'] =
        'Bearer ' + store.state.userState.access_token

      const response = await httpgst.put(url, payload, options)
      ctx.expense.extensions[payload.index].status = payload.status
      ctx.dialogViaticsAceptedExtension = false
      ctx.showNotification(response.data.message, 'success', -1)
      this.dispatch('approvals/getExpenses', ctx)
    } catch (error) {
      console.log(error.response)
      ctx.showNotification(error.response.data.message, 'error', -1)
      ctx.validateRequestActivated = false
    } finally {
      ctx.loadingDialog.extensionReject = false
      ctx.loadingDialog.extensionValidate = false
    }
  }
}

const mutations = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/modules/approvals/store/approvals.js